import Vue from 'vue';
import Router from 'vue-router';
import Home from "../views/home/index";
import store from '@/store'
Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    //路由中设置滚动
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/',
      name: '',
      component: Home,
      children: [
        {
          path: "/index",
          meta: { title: "首页" },
          name: "index",
          component: () => import("@/views/index")
        }, {
          path: "/college",
          meta: { title: "院校查询" },
          name: "college",
          component: () => import("@/views/college")
        }, {
          path: "/collegeDetail",
          meta: { title: "院校查询" },
          name: "collegeDetail",
          component: () => import("@/views/college/detail.vue")
        }, {
          path: "/major",
          meta: { title: "专业查询" },
          name: "major",
          component: () => import("@/views/major")
        }, {
          path: "/majorDetail",
          meta: { title: "专业详情" },
          name: "majorDetail",
          component: () => import("@/views/major/detail")
        }, {
          path: "/collegerank",
          meta: { title: "大学排行" },
          name: "collegerank",
          component: () => import("@/views/collegerank")
        }, {
          path: "/batch",
          meta: { title: "批次查询" },
          name: "batch",
          component: () => import("@/views/batch")
        }, {
          path: "/provincerank",
          meta: { title: "位次查询" },
          name: "provincerank",
          component: () => import("@/views/provincerank")
        }, {
          path: "/subject",
          meta: { title: "新高考选科" },
          name: "subject",
          component: () => import("@/views/subject")
        },
        {
          path: "/fillIn",
          meta: { title: "智能志愿填报" },
          name: "fillIn",
          component: () => import("@/views/fillIn")
        }, {
          path: "/user",
          meta: { title: "个人中心" },
          name: "user",
          component: () => import("@/views/user")
        },{
          path: "/choiceDetail",
          meta: { title: "志愿详情" },
          name: "choiceDetail",
          component: () => import("@/views/choiceDetail")
        }]
    }


  ]
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  if (to.path == '/user') {
    if (store.state.user.isLoginFlag) {
      next()
    } else {
      router.push('/index')
    }
  } else {
    next();
  }
});
export default router;
